// extracted by mini-css-extract-plugin
module.exports = {"Container":"MainView_Container__SgTVV","InstallBanner":"MainView_InstallBanner__pp80v","IconCross":"MainView_IconCross__JbwkR"};